import Favorite from 'actions/favorite';

export default Favorite.createReducer();